
<script>
 import { createEventDispatcher } from 'svelte';
 import { setSrc } from '../utils';
 import { staffMember, roomRequest } from '../stores';
 const dispatch = createEventDispatcher();

 export let item = {};
 //let src = "/icons/user.svg";

 function staffClick() {
   if (active == 1) {
     staffMember.set(0);
   } else {
    staffMember.set(item);
   dispatch('staffevent', {
     text: `${item.name} clicked`,
     item: item
   });
   }
 }

 $: active = $staffMember.guid == item.guid ? 1 : 0;
</script>

  <button type="button" on:click="{staffClick}" class="button staff-member" class:active={active} data-id="{item.guid}">
    <span class='icon'><span class="{item.icon}"></span><!--<img src={setSrc(src, item.image)} alt={item.name} >--></span>
    <span class="text">{item.name}</span>
  </button>
